import React from 'react'
import AjaxButton from "../../../form/ajax_button";
import classNames from "classnames";
import {updateTagOwnerMediaFileBookmarks} from "../../exhibition_actions";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";

export default function DownloadsPreview({hotspot, data, onModalClose}) {
  const {id,} = hotspot // SO stupid without this useSelector wont update
  const dispatch = useDispatch()
  const tagOwnerMediaFileBookmarkUrl = useSelector(state => state.tagOwnerMediaFileBookmarkUrl)
  const tagOwnerImageHotspotDownloadFileBookmarks = useSelector(state => state.tagOwnerImageHotspotDownloadFileBookmarks)
  const downloadFiles = useSelector(state => state.imageHotspotDownloadFiles.filter(df => df.image_hotspot_id == id ))
  const sortedDownloadFiles = _.sortBy(downloadFiles, ["position", "title", "filename", "id"], ["asc", "asc", "asc",])

  if (!sortedDownloadFiles) {
    return <div>Missing medial files.</div>
  }

  console.log("FUU", {tagOwnerMediaFileBookmarkUrl, tagOwnerImageHotspotDownloadFileBookmarks, sortedDownloadFiles})

  let mediaFileContent = null;
  if (sortedDownloadFiles && sortedDownloadFiles.length > 0) {
    mediaFileContent = <>
      {sortedDownloadFiles.map((mediaFile, index) => {
        const hasBookmarked = _.some(tagOwnerImageHotspotDownloadFileBookmarks, (bookmark) => {
          return bookmark.image_hotspot_download_file_id === mediaFile.id
        })

        return <div key={mediaFile.id}>
          {index > 0 ? <hr/> : null}
          <div dangerouslySetInnerHTML={{__html: mediaFile.description}}/>
          <a href={mediaFile.url} target="_BLANK" download>Download File</a>

          <br/>
          <AjaxButton
            method={hasBookmarked ? "delete" : "post"}
            label={hasBookmarked ? "Remove" : "Bookmark"}
            labelSending={hasBookmarked ? "Removing..." : "Bookmarking..."}
            className={classNames("btn btn-sm btn-dark btn-bookmark-download")}
            icon={hasBookmarked ? "fa-trash" : "fa-save"}
            url={hasBookmarked ? `${tagOwnerMediaFileBookmarkUrl}/${mediaFile.id}` : tagOwnerMediaFileBookmarkUrl}
            data={{
              media_file_id: mediaFile.id
            }}
            onSuccess={(data) => {
              if (data.data.status === "OK") {
                dispatch(updateTagOwnerMediaFileBookmarks(data.data.contactTagOwnerConnections))
              } else {
                alert(data.data.message || "A error occured while adding bookmark.")
              }
            }}
            onError={(error) => {
              console.log(error)
              alert("Error while adding bookmark", error)
            }}
          />
        </div>
      })}
    </>
  }

  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" onClick={(event) => {
        event.stopPropagation()
      }}>
        <div className="modal-header">
          <div className="modal-title">
            {data.title}
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              onModalClose ? onModalClose() : alert("No modal close action available.")
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {mediaFileContent}
        </div>
      </div>
    </div>
  </div>;
}
